import { render, staticRenderFns } from "./RedteaGo-mobile.vue?vue&type=template&id=4f12039e&scoped=true"
import script from "./RedteaGo-mobile.vue?vue&type=script&lang=js"
export * from "./RedteaGo-mobile.vue?vue&type=script&lang=js"
import style0 from "./RedteaGo-mobile.vue?vue&type=style&index=0&id=4f12039e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f12039e",
  null
  
)

export default component.exports